import React, { Component } from 'react';
import { Button, Card, Typography } from 'material-ui';
import Fade from 'material-ui/transitions/Fade';
import DemoAnimatedIcon from '../components/DemoAnimatedIcon';
import { Link } from 'react-router-dom';

import { Accent, Primary, PurpleShadow, Title } from '../helper/consts';

import '../styles/Pricing.css';

const options = [
	{
		title: 'Single Post',
		price: '499',
		currency: 'CAD',
		benefits: [
			'A beautiful Career Post page',
			'Shareable with employees',
			'Shareable with professional network',
			'Full network referral tracking'
		],
		link: '/AddJob'
	},
	{
		title: 'Super Post',
		price: '999',
		currency: 'CAD',
		benefits: [
			`Everything in Single Post, plus...`,
			'Algorithmic candidate screening',
			'Candidate profiles based on referral nodes',
			'Pre-screened list of qualified, referred candidates'
		]
	},
	{
		title: 'Super Post+',
		price: '1,499',
		currency: 'CAD',
		benefits: [
			`Everything in Super Post, plus...`,
			`Access to ${Title}'s network of successful referral nodes`,
			'Personal Recruitment Assistant'
		]
	}
];

const style = {
	pricingCard: {
		// backgroundColor: Primary,
		// color: 'white',
		boxShadow: `0 25px 93px -10px ${PurpleShadow}, 0 -5px 33px -10px ${PurpleShadow}`,
		textAlign: 'center',
		padding: '20px 10px'
	}
};

export default class Pricing extends Component {
	render() {
		return (
			<div className="body">
				<Fade in={true}>
					<div className="cardContainer">
						{options.map(option => {
							return (
								<Card style={style.pricingCard} className="card pricingCard">
									<Typography style={{ fontSize: '2rem', color: Accent }}>
										{option.title}
									</Typography>
									<DemoAnimatedIcon />
									<Typography style={{ fontSize: '1.3rem', color: Primary }}>
										{option.price}
										{option.currency}
									</Typography>
									<ul>
										{option.benefits.map(benefit => (
											<li
												style={{
													textAlign: 'left',
													margin: '11px 0',
													fontSize: '1.1rem',
													listStyle: 'none',
													color: Primary
												}}
											>
												{benefit}
											</li>
										))}
									</ul>
									{!!option.link ? (
										<Link to={option.link}>
											<Button
												style={{
													backgroundColor: Primary,
													color: 'white',
													margin: '21px',
													boxShadow: 'rgb(255, 64, 129) 0px 10px 50px -5px',
													minWidth: '150px',
													minHeight: '50px',
													borderRadius: '50px'
												}}
												raised={true}
											>
												Start
											</Button>
										</Link>
									) : (
										<Button>Coming Soon</Button>
									)}
								</Card>
							);
						})}
					</div>
				</Fade>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/Pricing.js